import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ChatTongole from './components/Chat/ChatTongole';
// Theme CSS is loaded via public/index.html <link>; remove invalid import outside src

// Ensure brand class is set on body before React renders
(() => {
  try {
    const host = window.location.hostname.toLowerCase();
    const origin = window.location.origin.toLowerCase();
    let brandClass = '';
    if (host.includes('rocket88') || origin.includes('rocket88')) {
      brandClass = 'rocket88';
    } else if (host.includes('bk8bd') || origin.includes('bk8bd')) {
      brandClass = 'bk8bd';
    } else if (host.includes('golden') || origin.includes('golden')) {
      brandClass = 'golden';
    } else if (host.includes('yellow') || origin.includes('yellow')) {
      brandClass = 'yellow';
    } else if (host.includes('cb444') || origin.includes('cb444')) {
      brandClass = 'cb444';
    } else if (host.includes('krikiya') || origin.includes('krikiya')) {
      brandClass = 'krikiya';
    }
    if (brandClass && document && document.body) {
      document.body.classList.add(brandClass);
    }
  } catch (e) {}
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ChatTongole hidden />
    <App />
  </BrowserRouter>
);
